import React from "react";
import Link from "components/link";
import { getButtonStyle } from "helpers/get-button-style";
import clsx from "clsx/lite";

const ButtonLink = ({ data = null, className = "" }) => {
	if (!data?.url || !data?.text || data?.hide) return null;

	return (
		<Link to={data.url}
			className={clsx(getButtonStyle(data.style, data.size, data.enableFullWidth), 
				className, "text-center", data.center && "mx-auto")}>
			{data.text}
		</Link>
	);
};

export default ButtonLink;